"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sumReceipts = exports.sumPaymentReceipts = void 0;
const sumPaymentReceipts = (payment, forGroupId) => {
    if (forGroupId && (payment === null || payment === void 0 ? void 0 : payment.receipts)) {
        const groupId = forGroupId === 'normal' ? 'internet' : forGroupId;
        return exports.sumReceipts(payment.receipts.
            filter(r => r.userGroupId === groupId));
    }
    return exports.sumReceipts(payment === null || payment === void 0 ? void 0 : payment.receipts);
};
exports.sumPaymentReceipts = sumPaymentReceipts;
const sumReceipts = (receipts) => {
    if (!receipts) {
        return 0;
    }
    return receipts.reduce((sum, r) => sum + r.amountInEuro, 0);
};
exports.sumReceipts = sumReceipts;
//# sourceMappingURL=sumPaymentReceipts.js.map